import { AppError } from './app-error';
import { Http } from '@angular/http';
import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

@Injectable()
export class HttpService {
  constructor(private http: HttpClient) { }

  getAll(url) {
    return this.http.get(url)
      .catch(this.handleError);
  }
  get(url) {
    return this.http.get(url)
      .catch(this.handleError);
  }

  create(url,resource) {
    return this.http.post(url, resource)
      .catch(this.handleError);
  }

  fetch(url,resource) {
    return this.http.post(url, resource)
      .catch(this.handleError);
  }

  update(url, resource) {
    return this.http.put(url, resource)
      .catch(this.handleError);
  }

  delete(url) {
    return this.http.delete(url)
      .catch(this.handleError);
  }

  private handleError(error: Response) {    
    return Observable.throw(new AppError(error));
  }

}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/_shared/services/Http.service.ts